import React, { memo } from 'react';
import classNames from 'classnames';
import { TrolleyInactive } from '@johnlewispartnership/wtr-ingredients/foundations/icons';

import styles from './TrolleySize.scss';

interface TrolleySizeProps {
  highlightValue?: boolean;
}

const TrolleySize = ({ highlightValue = true }: TrolleySizeProps) => {
  return (
    <span
      data-testid="trolley-size-container"
      className={classNames(styles.trolleySize, {
        [styles.highlight]: highlightValue,
      })}
    >
      <div className={styles.icon}>
        <TrolleyInactive size="small" />
      </div>
    </span>
  );
};

export default memo(TrolleySize);
